<template>
    <div >

        <!-- 1) boolean settings  -->
        <div class="TQ_padding_16px TQ_border_bottom">

            <!-- 1.1) quest Type-->
            <div class="TQ_margin_0_8px TQ_inline">

                <div class="TQ_text_20px">
                    {{ass_strings.twoWords_playingMode[p_store_systemLangCode_e]}}
                </div>

                <div class="TQ_inline TQ_padding_8px TQ_box_shadow TQ_margin_4px TQ_borderRadius TQ_width_100px TQ_bg_hover_goldLite TQ_clickable TQ_bg_gray4 "
                     :class="p_questBody_c.qb_metadata_c.qbm_quest_questMode_e === enum_questTeamsType_s.teams && 'TQ_bg_gold'"
                     @click="p_questBody_c.qb_metadata_c.qbm_quest_questMode_e = enum_questTeamsType_s.teams">
                    <tq-image :pb_src_r="ass_img_playersGroup_b" class="TQ_width_44px"/>
                    <div>
                        {{ass_strings.oneWord_teams[p_store_systemLangCode_e]}}
                    </div>
                </div>

                <div class="TQ_inline TQ_padding_8px TQ_box_shadow TQ_margin_4px TQ_borderRadius TQ_width_100px TQ_bg_hover_goldLite TQ_clickable TQ_bg_gray4"
                     :class="p_questBody_c.qb_metadata_c.qbm_quest_questMode_e === enum_questTeamsType_s.individual && 'TQ_bg_gold'"
                     @click="p_questBody_c.qb_metadata_c.qbm_quest_questMode_e = enum_questTeamsType_s.individual">
                    <tq-image :pb_src_r="ass_img_user_b" class="TQ_width_44px"/>
                    <div>
                        {{ass_strings.twoWords_singlePlayer[p_store_systemLangCode_e]}}
                    </div>
                </div>


            </div>

            <!-- 1.2) chat -->
            <div class="TQ_margin_0_8px TQ_inline">

                <div class="TQ_text_20px">
                    {{ ass_strings.oneWord_chat[p_store_systemLangCode_e] }}
                </div>

                <div class="TQ_inline TQ_padding_8px TQ_box_shadow TQ_margin_4px TQ_borderRadius TQ_width_100px TQ_bg_hover_goldLite TQ_clickable TQ_bg_gray4 "
                     :class="p_questBody_c.qb_metadata_c.qbm_quest_supportChat_b && 'TQ_bg_gold'"
                     @click="p_questBody_c.qb_metadata_c.qbm_quest_supportChat_b = true">
                    <tq-image :pb_src_r="ass_img_chat_b" class="TQ_width_44px"/>
                    <div class="TQ_text_capitalize">
                        {{ ass_strings.oneWord_active[p_store_systemLangCode_e] }}
                    </div>
                </div>

                <div class="TQ_inline TQ_padding_8px TQ_box_shadow TQ_margin_4px TQ_borderRadius TQ_width_100px TQ_bg_hover_goldLite TQ_clickable TQ_bg_gray4"
                     :class="!p_questBody_c.qb_metadata_c.qbm_quest_supportChat_b && 'TQ_bg_gold'"
                     @click="p_questBody_c.qb_metadata_c.qbm_quest_supportChat_b = false; p_questBody_c.qb_metadata_c.qbm_quest_supportChatTranslate_b = false">
                    <tq-image :pb_src_r="ass_img_disable_b" class="TQ_width_44px"/>
                    <div class="TQ_text_capitalize">
                        {{ ass_strings.oneWord_disable[p_store_systemLangCode_e] }}
                    </div>
                </div>

            </div>

            <!-- 1.3) chat translation -->
            <div class="TQ_margin_0_8px TQ_inline" >

                <div class="TQ_text_20px">
                    {{ass_strings.twoWords_chatTranslation[p_store_systemLangCode_e]}}
                </div>


                <div class="TQ_inline TQ_padding_8px TQ_box_shadow TQ_margin_4px TQ_borderRadius TQ_width_100px TQ_bg_hover_goldLite TQ_clickable TQ_bg_gray4 "
                     :class="p_questBody_c.qb_metadata_c.qbm_quest_supportChatTranslate_b && 'TQ_bg_gold'"
                     @click="p_questBody_c.qb_metadata_c.qbm_quest_supportChatTranslate_b = p_questBody_c.qb_metadata_c.qbm_quest_supportChat_b">
                    <tq-image :pb_src_r="ass_img_language_b" class="TQ_width_44px"/>
                    <div class="TQ_text_capitalize">
                        {{ ass_strings.oneWord_active[p_store_systemLangCode_e] }}
                    </div>
                </div>

                <div class="TQ_inline TQ_padding_8px TQ_box_shadow TQ_margin_4px TQ_borderRadius TQ_width_100px TQ_bg_hover_goldLite TQ_clickable TQ_bg_gray4"
                     :class="!p_questBody_c.qb_metadata_c.qbm_quest_supportChatTranslate_b && 'TQ_bg_gold'"
                     @click="p_questBody_c.qb_metadata_c.qbm_quest_supportChatTranslate_b = false">
                    <tq-image :pb_src_r="ass_img_disable_b" class="TQ_width_44px"/>
                    <div class="TQ_text_capitalize">
                        {{ ass_strings.oneWord_disable[p_store_systemLangCode_e] }}
                    </div>
                </div>

            </div>

        </div>

        <!-- 1) skips -->
        <div class="TQ_padding_16px TQ_border_bottom" >

            <div class="TQ_inline TQ_verticalAlignTop">

                <div class="TQ_align_initial TQ_text_20px ">{{ass_strings.oneWord_skips[p_store_systemLangCode_e]}}</div>
                <tq-toggle-switch v-model="p_questBody_c.qb_metadata_c.qbm_missions_supportSkips_b" />

            </div>
            <div class="TQ_padding_8px TQ_inline TQ_verticalAlignTop"></div>

            <div class="TQ_maxWidth_200px TQ_inline TQ_verticalAlignTop">
                <div class="TQ_align_initial TQ_text_20px" :class="!p_questBody_c.qb_metadata_c.qbm_missions_supportSkips_b && 'TQ_textColor_gray TQ_text_lineThrough'">
                    {{ass_strings.twoWords_startingSkips[p_store_systemLangCode_e]}}
                </div>
                <input class="TQ_input TQ_text_20px"
                       :disabled="!p_questBody_c.qb_metadata_c.qbm_missions_supportSkips_b"
                       :class="!p_questBody_c.qb_metadata_c.qbm_missions_supportSkips_b && 'TQ_textColor_gray TQ_text_lineThrough'"
                       type="number"
                       v-model.number="p_questBody_c.qb_startingSkipsNum_n"/>

            </div>

        </div>

        <!-- 2) hints type -->
        <div class="TQ_padding_16px TQ_border_bottom" >
            <div class="TQ_maxWidth_450px TQ_inline TQ_width_100p TQ_align_initial">

                <!-- hint type -->
                <div class="TQ_inline TQ_verticalAlignTop">
                    <!-- title -->
                    <div class="TQ_align_initial TQ_text_20px">
                        {{ ass_strings.oneWord_hints[p_store_systemLangCode_e] }}
                    </div>

                    <!-- dropdown -->
                    <tq-dropdown class="TQ_border TQ_clickable TQ_width_150px" :ps_only-mobile-mode_b="true">

                        <div slot="select" class="TQ_padding_8px ">
                            {{m_formatHintsMode_fs(p_questBody_c.qb_metadata_c.qbm_missions_cluesMode_e)}}
                        </div>

                        <div slot="options" class="TQ_border TQ_padding_8px TQ_bg_hover_purple"
                             @click="p_questBody_c.qb_metadata_c.qbm_missions_cluesMode_e = clueMode_e"
                             v-for="clueMode_e in enum_cluesMode_e">
                            {{m_formatHintsMode_fs(clueMode_e)}}
                        </div>
                    </tq-dropdown>
                </div>

                <!-- space -->
                <div class="TQ_padding_4px TQ_verticalAlignTop TQ_inline"></div>

                <!-- number of hints -->
                <div class="TQ_inline TQ_verticalAlignTop"
                     :class="![enum_cluesMode_e.counter, enum_cluesMode_e.counter_gradual].includes(p_questBody_c.qb_metadata_c.qbm_missions_cluesMode_e) && 'TQ_textColor_gray TQ_text_lineThrough'">
                    <div class="TQ_align_initial TQ_text_20px">{{ ass_strings.twoWords_startingHints[p_store_systemLangCode_e] }}</div>
                    <input :disabled="![enum_cluesMode_e.counter, enum_cluesMode_e.counter_gradual].includes(p_questBody_c.qb_metadata_c.qbm_missions_cluesMode_e)"
                           :class="![enum_cluesMode_e.counter, enum_cluesMode_e.counter_gradual].includes(p_questBody_c.qb_metadata_c.qbm_missions_cluesMode_e) && 'TQ_textColor_gray TQ_text_lineThrough'"
                           class="TQ_input TQ_text_20px " type="number" v-model.number="p_questBody_c.qb_startingCluesNum_n"/>
                </div>

            </div>



        </div>

        <!-- 3) audio -->
        <div class="TQ_padding_16px TQ_border_bottom" >
            <div class="TQ_maxWidth_600px TQ_inline TQ_width_100p ">

                <div class="TQ_align_initial TQ_text_20px">
                    {{ ass_strings.oneWord_audio[p_store_systemLangCode_e] }}
                </div>
                <table class="TQ_width_100p TQ_borderRadius ">
                    <tr v-for="(rowData_o, index_n) in co_audioTableData_ao">
                        <td class="TQ_bg_gray3">
                            {{rowData_o.title_s}}
                        </td>
                        <td>
                            <div v-if="rowData_o.audioUrl_s" class="TQ_grid_col_1frAuto TQ_grid_gap_4px">

                                <audio class="TQ_grid_center TQ_width_250px" controls controlsList="nodownload noplaybackrate">
                                    <source :src="rowData_o.audioUrl_s">
                                </audio>

                            </div>
                            <div v-else>
                                {{ass_strings.oneWord_muted}}
                            </div>
                        </td>
                        <td >
                            <tq-image :pb_src_r="ass_img_edit_b"
                                      title="edit"
                                      @click.native="m_chooseAudio_f(index_n)"
                                      class="TQ_padding_8px TQ_width_28px TQ_clickable TQ_Animation_smallBigSmall_infinite_hover TQ_grid_center"/>

                            <tq-image :pb_src_r="ass_svg_muteSpeakers_b"
                                      title="mute"
                                      v-if="rowData_o.audioUrl_s"
                                      @click.native="m_deleteAudio_f(index_n)"
                                      class="TQ_padding_8px TQ_width_28px TQ_clickable TQ_Animation_smallBigSmall_infinite_hover TQ_grid_center"/>

                            <tq-image :pb_src_r="ass_svg_arrow_return_b"
                                      title="return to default"
                                      v-if="rowData_o.audioUrl_s !== rowData_o.default_s"
                                      @click.native="rowData_o.updateAudioFile_f(rowData_o.default_s)"
                                      class="TQ_padding_8px TQ_width_28px TQ_clickable TQ_Animation_smallBigSmall_infinite_hover TQ_grid_center"/>
                        </td>
                    </tr>

                </table>
            </div>

        </div>

        <!-- 4) background image -->
        <div class="TQ_padding_16px " >
            <div class="TQ_maxWidth_600px TQ_borderRadius TQ_center">

                <!-- title -->
                <div class="TQ_text_capitalize borderRadius_top TQ_align_initial TQ_text_20px">
                    {{ ass_strings.threeWords_questBackgroundImage[p_store_systemLangCode_e] }}
                </div>

                <!-- body-->
                <tq-on-top-container>

                    <div slot="body" @click="m_chooseBackGroundImage_f" class="TQ_padding_12px TQ_box_shadow TQ_bg_gray4 TQ_margin_4px TQ_clickable TQ_borderRadius">
                        <tq-img-fill-blur :pp_imgUrl_s="p_questBody_c.qb_theme_c.qbt_backgroundImg_s ? p_questBody_c.qb_theme_c.qbt_backgroundImg_s : ass_img_image2" p_height_s="250px"/>
                    </div>

                    <tq-image @click.native="p_questBody_c.qb_theme_c.qbt_backgroundImg_s = ''"
                              v-if="p_questBody_c.qb_theme_c.qbt_backgroundImg_s" slot="topRight" :pb_src_r="ass_img_closeRed" class="TQ_width_24px TQ_clickable" />
                </tq-on-top-container>
            </div>
        </div>

    </div>
</template>

<script>
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        enum_audioUrl,
        enum_cluesMode_e, enum_featuresMinPoints, enum_moreInfo_featuresIds_s, enum_questMode_s,
    } from "../../../../../functions/src/shareCode/Share_S_Enum";
    import {helper_getFbClassSize_s} from "@/scripts/S_Helper";
    import TqImage from "@/components/basic/TqImage";
    import {
        ass_img_chat_b, ass_img_chat_disable_b,
        ass_img_closeRed, ass_img_disable_b,
        ass_img_edit_b,
        ass_img_image2, ass_img_language_b, ass_img_language_disable_b,
        ass_img_playersGroup_b,
        ass_img_playVideo_c,
        ass_img_user_b,
        ass_svg_arrow_return_b,
        ass_svg_muteSpeakers_b
    } from "@/assets/scripts/Ass_Files";
    import TqOnTopContainer from "@/components/basic/TqOnTopContainer";
    import TqImgFillBlur from "@/components/basic2/TqImgFillBlur";
    import TqMoreInfo from "@/components/basic2/TqMoreInfo";
    import {FB_QuestBody, FB_UserData} from "../../../../../functions/src/shareCode/Share_S_Classes";
    import TqDropdown from "@/components/basic/TqDropdown";
    import TqToggleSwitch from "@/components/basic/TqToggleSwitch";

    export default {
        name: "c_Creator_EditQuests_Item_BodyBasic",
        components: {
            TqToggleSwitch,
            TqDropdown,
            TqMoreInfo,
            TqImgFillBlur,
            TqOnTopContainer,
            TqImage,
        },
        props:{
            p_questBody_c:{
                type: FB_QuestBody,
                require: true,
            },
            p_store_systemLangCode_e:{
                type: String,
                require: true,
            },
            p_creatorData_c:{
                type: FB_UserData,
                require: true
            },
            pe_chooseFile_f: {
                type: Function,
                require: true,
            },
        },
        data(){
            return {

                server_creatorData_c : undefined,

                // imports
                ass_strings: ass_strings,
                helper_getFbClassSize_s : helper_getFbClassSize_s,
                enum_cluesMode_e : enum_cluesMode_e,
                ass_img_playVideo_c: ass_img_playVideo_c,
                ass_img_edit_b: ass_img_edit_b,
                ass_svg_muteSpeakers_b: ass_svg_muteSpeakers_b,
                ass_svg_arrow_return_b: ass_svg_arrow_return_b,
                ass_img_closeRed: ass_img_closeRed,
                ass_img_image2          : ass_img_image2,
                ass_img_user_b          : ass_img_user_b,
                ass_img_playersGroup_b          : ass_img_playersGroup_b,
                ass_img_chat_b          : ass_img_chat_b,
                ass_img_language_b          : ass_img_language_b,
                ass_img_disable_b          : ass_img_disable_b,

                enum_moreInfo_featuresIds_s      : enum_moreInfo_featuresIds_s,
                enum_featuresMinPoints      : enum_featuresMinPoints,
                enum_questTeamsType_s      : enum_questMode_s,
            }
        },
        computed: {
            co_audioTableData_ao(){
                return [


                    // chat
                    this.p_questBody_c.qb_metadata_c.qbm_quest_supportChat_b && {
                        title_s : ass_strings.oneWord_chat[this.p_store_systemLangCode_e],
                        audioUrl_s : this.p_questBody_c.qb_metadata_c.qbm_audio_chatUrl_s,
                        updateAudioFile_f: newAudioUrl_s => this.p_questBody_c.qb_metadata_c.qbm_audio_chatUrl_s = newAudioUrl_s,
                        default_s: enum_audioUrl.notify_s,
                    },

                    // list missions
                    this.p_questBody_c.qb_metadata_c.qbm_quest_supportListMissions_b && {
                        title_s : ass_strings.twoWords_missionsList[this.p_store_systemLangCode_e],
                        audioUrl_s : this.p_questBody_c.qb_metadata_c.qbm_audio_listMissionsUrl_s,
                        updateAudioFile_f: newAudioUrl_s => this.p_questBody_c.qb_metadata_c.qbm_audio_listMissionsUrl_s = newAudioUrl_s,
                        default_s: enum_audioUrl.claps_s,
                    },

                    // cards missions
                    this.p_questBody_c.qb_metadata_c.qbm_quest_supportCardsMissions_b && {
                        title_s : ass_strings.twoWords_cardsMissions[this.p_store_systemLangCode_e],
                        audioUrl_s : this.p_questBody_c.qb_metadata_c.qbm_audio_cardsMissionsUrl_s,
                        updateAudioFile_f: newAudioUrl_s => this.p_questBody_c.qb_metadata_c.qbm_audio_cardsMissionsUrl_s = newAudioUrl_s,
                        default_s: enum_audioUrl.claps_s,

                    },
                    // map missions
                    this.p_questBody_c.qb_metadata_c.qbm_quest_supportMapMissions_b && {
                        title_s : ass_strings.twoWords_mapMissions[this.p_store_systemLangCode_e],
                        audioUrl_s : this.p_questBody_c.qb_metadata_c.qbm_audio_mapMissionsUrl_s,
                        updateAudioFile_f: newAudioUrl_s => this.p_questBody_c.qb_metadata_c.qbm_audio_mapMissionsUrl_s = newAudioUrl_s,
                        default_s: enum_audioUrl.claps_s,

                    },

                    // last missions
                    {
                        title_s : ass_strings.twoWords_lastMissions[this.p_store_systemLangCode_e],
                        audioUrl_s : this.p_questBody_c.qb_metadata_c.qbm_audio_lastMissionsUrl_s,
                        updateAudioFile_f: newAudioUrl_s => this.p_questBody_c.qb_metadata_c.qbm_audio_lastMissionsUrl_s = newAudioUrl_s,
                        default_s: enum_audioUrl.lastRiddle_s,
                    },

                    // Wrong answer error
                    {
                        title_s : ass_strings.twoWords_wrongAnswer[this.p_store_systemLangCode_e],
                        audioUrl_s : this.p_questBody_c.qb_metadata_c.qbm_audio_missionErrorUrl_s,
                        updateAudioFile_f: newAudioUrl_s => this.p_questBody_c.qb_metadata_c.qbm_audio_missionErrorUrl_s = newAudioUrl_s,
                        default_s: enum_audioUrl.error_s,
                    },

                ].filter(item => item)
            },
        },
        methods:{
            m_chooseBackGroundImage_f(){

                this.pe_chooseFile_f( (newFile_c) =>{
                    this.p_questBody_c.qb_theme_c.qbt_backgroundImg_s = newFile_c.fi_url_s
                })
            },
            m_chooseAudio_f(index_n){
                this.pe_chooseFile_f( (newAudioFile_c) =>{
                    this.co_audioTableData_ao[index_n].updateAudioFile_f(newAudioFile_c.fi_url_s)
                }, false, false, true)
            },
            m_deleteAudio_f(index_n){
                this.co_audioTableData_ao[index_n].updateAudioFile_f(null)
            },
            m_formatHintsMode_fs(hintMode_e){
                switch(hintMode_e){
                    case enum_cluesMode_e.none:
                        return ass_strings.oneWord_disable[this.p_store_systemLangCode_e]
                    case enum_cluesMode_e.counter:
                        return ass_strings.oneWord_counter[this.p_store_systemLangCode_e]
                    case enum_cluesMode_e.counter_gradual:
                        return ass_strings.twoWords_counterGradual[this.p_store_systemLangCode_e]
                    case enum_cluesMode_e.points:
                        return ass_strings.oneWord_points[this.p_store_systemLangCode_e]
                    case enum_cluesMode_e.points_gradual:
                        return ass_strings.twoWords_pointsGradual[this.p_store_systemLangCode_e]
                }
            }
        },

    }
</script>

<style scoped lang="scss">


table{
    background: white;
    //border-collapse: collapse;
    //display: inline-block;
    border: 1px solid black;

    td{
        padding: 8px;
        border: 1px solid black;
    }

}

</style>
